import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=83476878&scoped=true"
import script from "./Gateways.vue?vue&type=script&lang=js"
export * from "./Gateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83476878",
  null
  
)

export default component.exports